// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4034":"f2a0b7e5","5673":"baea0837","7241":"a4a1deec"}[chunkId] + ".chunk.css";
};